import React, { useState, useEffect, Fragment, useContext } from "react";
import { useParams } from "react-router-dom";
import * as CONST from "../../../component/config/Constant";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../../component/context/AuthContext";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import Form from "../../../component/utilities/Forms";
import { Helmet } from "react-helmet";
import { FiArrowLeft, FiCode } from "react-icons/fi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import "../../../assets/css/home.css";

function Technologies() {
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [activeBtn, setActiveBtn] = useState("next");
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [listLimit, setListLimit] = useState(50);
  const [techQuestionData, setTechQuestionData] = useState([]);
  const [technologyName, setTechnologyName] = useState("");
  const [versions, setVersions] = useState([]);
  const [techVersion, setTechVersion] = useState("");
  const [techVersionId, setTechVersionId] = useState("");
  const [questionDescription, setQuestionDescription] = useState("");
  const [questionIndex, setQuestionIndex] = useState(0);
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [validate, setValidate] = useState({});
  const [questCommentData, setQuestCommentData] = useState([]);
  const [isReply, setIsReply] = useState(false);
  const [isCommentId, setIsCommentId] = useState("");
  const [commentIndex, setCommentIndex] = useState("");
  const [userReply, setUserReply] = useState("");
  const [isEditingReply, setIsEditingReply] = useState("");
  const [editingReplyText, setEditingReplyText] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 400);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  /* START DATATABLE */
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  //Search
  const [searchTechnologyStatus, setSearchTechnologyStatus] = useState("");
  const [dataSort, setDataSort] = useState({
    order: "desc",
    order_by: "id",
  });

  const [searchParam, setSearchParam] = useState({
    srchStatus: searchTechnologyStatus,
  });

  //Comment Sort
  const [commentDataSort, setCommentDataSort] = useState({
    order: "desc",
    order_by: "id",
  });

  //comment limit
  const [commentPerPage, setCommentPerPage] = useState(10);
  //page no
  const [commentActivePage, setCommentActivePage] = useState(1);

  const params = useParams();
  let technologyId = params.id;

  let isToken = "";
  let loginUserName = "";
  let loginUserEmail = "";
  let loginUserId = "";

  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
      var fname = authUserData[0].first_name ? authUserData[0].first_name : "";
      var lname = authUserData[0].last_name ? authUserData[0].last_name : "";
      if (fname !== "" && lname !== "") {
        loginUserName = fname + " " + lname;
      }
      loginUserEmail = authUserData[0].email ? authUserData[0].email : "";
      loginUserId = authUserData[0].user_id ? authUserData[0].user_id : "";
    }
  }
  const styles = {
    checkUserStyle: {
      display: loginUserId ? "none" : "block",
    },
  };

  const getRelativeTime = (date) => {
  if (!date) return "";   // already correct
  const momentDate = moment(date);
 
  if (momentDate.isSame(moment(), "day")) {
    return "Today";
  }
  return momentDate.fromNow();
};

  useEffect(() => {
    fetchTechnologyById(technologyId);
    setUserName(loginUserName);
    setEmail(loginUserEmail);
  }, []);

  const replyHandler = (commentId, index) => {
    setIsReply(!isReply);
    setIsCommentId(commentId);
    setCommentIndex(index);
  };


  const handleOnchange = (e) => {
    //console.log("val >>> ");
    //console.log(e.target);
    //console.log(e.target.children);
    //console.log(e.target.value);

    var index = e.nativeEvent.target.selectedIndex;
    // e.nativeEvent.target[index].text;
    // console.log("label >>> ");
    // console.log(e.nativeEvent.target[index].text);
    var val = e.nativeEvent.target[index].text;
    var versionId = e.target.value;

    setTechVersion(val);
    setTechVersionId(versionId);
    fetchTechnologyQuestionData(
      searchParam,
      dataSort,
      activePage,
      perPage,
      technologyId,
      val,
      versionId,
    );
    //console.log("questionId >> " + questionId);
    // fetchQuestionCommentReplyList(
    //   commentDataSort,
    //   commentActivePage,
    //   commentPerPage,
    //   versionId
    // );
  };

  const handlePrevDescription = (prevIndex) => {
    if (techQuestionData.length > prevIndex) {
      const strDescription =
        techQuestionData[prevIndex].questionData.description;
      setQuestionDescription(strDescription);
    }
    setQuestionIndex(prevIndex);
    setActiveBtn("prev");
    //fetchQuestionCommentReplyList(commentDataSort,commentActivePage,commentPerPage,techVersionId,qId);
  };

  const handleNextDescription = (nextIndex) => {
    if (techQuestionData.length > nextIndex) {
      const strDescription =
        techQuestionData[nextIndex].questionData.description;
      setQuestionDescription(strDescription);
    }
    setQuestionIndex(nextIndex);
    setActiveBtn("next");
    //fetchQuestionCommentReplyList(commentDataSort,commentActivePage,commentPerPage,techVersionId,qId);
  };

  const handleGetDescription = (qId, index) => {
    const descriptionData = techQuestionData.filter(
      (d) => d.questionData.id === qId,
    )[0].questionData.description;
    setQuestionDescription(descriptionData);
    var intIndex = index;
    setQuestionIndex(intIndex);

    fetchQuestionCommentReplyList(
      commentDataSort,
      commentActivePage,
      commentPerPage,
      techVersionId,
      qId,
    );
  };

  const submitComment = async (e) => {
    e.preventDefault();
    let isValid = true;

    // Only validate name and email if user is NOT logged in
    let validatorSchema = {
      comment: {
        value: comment,
        isRequired: true,
        label: "Comment",
      },
    };

    if (!loginUserId) {
      validatorSchema.userName = {
        value: userName,
        isRequired: true,
        label: "User Name",
      };
      validatorSchema.email = {
        value: email,
        isRequired: true,
        label: "Email",
      };
    }

    let validator = Form.validator(validatorSchema);

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    } else {
      setValidate({
        validate: "",
      });
      isValid = true;
    }
    if (isValid) {
      if (technologyId !== 0) {
        await axios({
          method: "post",
          url: CONST.ADD_COMMENT_FOR_QUESTION,
          data: {
            name: loginUserId ? loginUserName : userName,
            email: loginUserId ? loginUserEmail : email,
            comment: comment,
            technology_id: technologyId,
            question_id: techQuestionData[questionIndex].question_id,
            version_id: techQuestionData[questionIndex].version_id,
            user_id: loginUserId !== "" ? loginUserId : 0,
            is_guest_user: loginUserId !== "" ? 0 : 1,
          },
        })
          .then((response) => {
            if (response) {
              if (response.data.status == "error") {
                toast.error("Something went wrong. Please try again.");
              } else {
                toast.success("Comment added succesfully");
                setComment("");
                setEmail(loginUserId ? loginUserEmail : "");
                setUserName(loginUserId ? loginUserName : "");
                // Refetch comments so the new one appears immediately
                fetchQuestionCommentReplyList(
                  commentDataSort,
                  commentActivePage,
                  commentPerPage,
                  techVersionId,
                  techQuestionData[questionIndex].question_id
                );
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            toast.error("Something went wrong. Please try again.");
          });
      }
    }
  };

  const submitReply = async (e, commentId) => {
    e.preventDefault();
    if (!userReply.trim()) {
      toast.error("Reply cannot be empty");
      return;
    }

    if (technologyId !== 0) {
      await axios({
        method: "post",
        url: CONST.ADD_COMMENT_REPLY,
        data: {
          reply: userReply,
          comment_id: commentId,
          technology_id: technologyId,
          question_id: techQuestionData[questionIndex].question_id,
          version_id: techQuestionData[questionIndex].version_id,
          user_id: loginUserId !== "" ? loginUserId : 0,
        },
        headers: {
          Authorization: `Bearer ${isToken}`,
        },
      })
        .then((response) => {
          if (response) {
            if (response.data.status === "error") {
              toast.error("Something went wrong. Please try again.");
            } else {
              toast.success("Reply added successfully");
              setUserReply("");
              setIsReply(false);
              setIsCommentId("");
              // Refetch comments so the new reply appears
              fetchQuestionCommentReplyList(
                commentDataSort,
                commentActivePage,
                commentPerPage,
                techVersionId,
                techQuestionData[questionIndex].question_id
              );
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Something went wrong. Please try again.");
        });
    }
  };
  const filteredQuestionData = techQuestionData.filter((qData) => {
    if (!debouncedSearch) return true;
    const searchLower = debouncedSearch.toLowerCase();
    const title = qData.questionData?.title || "";
    const description = qData.questionData?.description || "";
    const cleanDescription = description.replace(/<[^>]*>?/gm, "");

    return (
      title.toLowerCase().includes(searchLower) ||
      cleanDescription.toLowerCase().includes(searchLower)
    );
  });

  const getHighlightedDescription = (desc) => {
    if (!debouncedSearch || !desc) return desc || "";
    try {
      const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const searchPattern = escapeRegExp(debouncedSearch);
      const regex = new RegExp(`(?![^<]*>)(${searchPattern})`, "gi");
      return desc.replace(regex, "<mark className='bg-primary text-white'>$1</mark>");
    } catch (e) {
      return desc;
    }
  };

  const deleteReply = async (replyId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to delete this reply?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios({
          method: "delete",
          url: CONST.DELETE_COMMENT_REPLY,
          data: {
            reply_id: replyId,
          },
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        })
          .then((response) => {
            if (response && response.data.status === "success") {
              toast.success("Reply deleted successfully");
              fetchQuestionCommentReplyList(
                commentDataSort,
                commentActivePage,
                commentPerPage,
                techVersionId,
                techQuestionData[questionIndex].question_id
              );
            } else {
              toast.error(response.data.message || "Something went wrong");
            }
          })
          .catch((error) => {
            toast.error("Something went wrong. Please try again.");
          });
      }
    });
  };

  const updateReply = async (replyId) => {
    if (!editingReplyText.trim()) {
      toast.error("Reply cannot be empty");
      return;
    }

    await axios({
      method: "put",
      url: CONST.UPDATE_COMMENT_REPLY,
      data: {
        reply_id: replyId,
        reply: editingReplyText,
      },
      headers: {
        Authorization: `Bearer ${isToken}`,
      },
    })
      .then((response) => {
        if (response && response.data.status === "success") {
          toast.success("Reply updated successfully");
          setIsEditingReply("");
          setEditingReplyText("");
          fetchQuestionCommentReplyList(
            commentDataSort,
            commentActivePage,
            commentPerPage,
            techVersionId,
            techQuestionData[questionIndex].question_id
          );
        } else {
          toast.error(response.data.message || "Something went wrong");
        }
      })
      .catch((error) => {
        toast.error("Something went wrong. Please try again.");
      });
  };

  //fetch all question comment reply details
  async function fetchQuestionCommentReplyList(
    paramSort,
    paramPage,
    paramLimit,
    versionId,
    questionId,
  ) {
    setLoading(true);

    await axios
      .post(CONST.GET_QUESTION_COMMENT_REPLY_DETAILS, {
        question_id: questionId,
        version_id: versionId,
        limit: paramLimit,
        page_number: paramPage,
        sort: paramSort,
      })
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          setQuestCommentData(response.data.data);
          // setQuestionDescription(
          //   response.data.data[0].questionData.description
          // );
        } else {
          // toast.error(response.data.message);
          setQuestCommentData("");
          //setQuestionDescription("");
        }
      })
      .catch((error) => { });
    setLoading(false);
  }

  //fetch all technology details
  async function fetchTechnologyQuestionData(
    paramSearch,
    paramSort,
    paramPage,
    paramLimit,
    technologyId,
    techVersion,
    versionId,
  ) {
    setLoading(true);

    await axios
      .post(CONST.GET_TECH_QUESTIONS, {
        technology_id: technologyId,
        version: techVersion,
        limit: paramLimit,
        search_input: paramSearch,
        page_number: paramPage,
        sort: paramSort,
      })
      .then((response) => {
        const status = response.data.status;
        if (status === "success" && response.data.data.length > 0) {
          // --- SORTING LOGIC ---
          // We create a shallow copy with [...] because .sort() mutates the original array
          const sortedData = [...response.data.data].sort((a, b) => {
            return (a.display_order || 0) - (b.display_order || 0);
          });

          setTechQuestionData(sortedData);
          setTotalRows(response.data.count);

          // Use the first item from the SORTED list for initial display
          const firstQuestion = sortedData[0];
          setQuestionDescription(firstQuestion.questionData.description);

          fetchQuestionCommentReplyList(
            commentDataSort,
            commentActivePage,
            commentPerPage,
            versionId,
            firstQuestion.question_id,
          );
        } else {
          // Handle empty state gracefully
          setTechQuestionData([]);
          setQuestionDescription("");
          if (status !== "success") toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
      });
    setLoading(false);
  }

  async function fetchTechnologyById(technologyId) {
    setLoading(true);
    let apiUrl = CONST.GET_TECH_DETAILS_BY_ID + `${technologyId}`;

    try {
      const response = await axios.put(apiUrl); // Using await directly is cleaner
      const { status, data: technologyData } = response.data;

      if (status === "success" && technologyData) {
        setTechnologyName(technologyData.name || "");

        // FIX: Look for 'versions' instead of 'technologies_has_versions'
        const arrVersion = Array.isArray(technologyData.versions)
          ? technologyData.versions.map((v) => ({
            id: v.id,
            value: v.version, // Maps "12.2" to the 'value' key used in your JSX
          }))
          : []; // Fallback to empty array, NEVER an empty string

        setVersions(arrVersion);
      }
    } catch (error) {
      console.error("Error fetching tech details:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <style>
        {`
          /* For Webkit: Chrome, Safari, Edge */
          .custom-scroll::-webkit-scrollbar { width: 7px; height: 7px; }
          .custom-scroll::-webkit-scrollbar-track { background: #f8f9fa; border-radius: 10px; }
          .custom-scroll::-webkit-scrollbar-thumb { background: #adb5bd; border-radius: 10px; border: 2px solid #f8f9fa; }
          .custom-scroll::-webkit-scrollbar-thumb:hover { background: #6c757d; }

          /* For Firefox */
          .custom-scroll {
            scrollbar-width: thin;
            scrollbar-color: #adb5bd #f8f9fa;
          }
          
          .scrollable { overflow-y: auto !important; }
        `}
      </style>
      <Helmet><title>{`${technologyName || 'Technology'} | HRD Portal - eLuminous Technologies`}</title></Helmet>

      <section className="tech-detail-hero">
        <div className="container">
          <Link to="/technologies" className="tech-detail-back"><FiArrowLeft /> Back to Technologies</Link>
          <div className="tech-hero-row">
            <div className="tech-hero-icon"><FiCode /></div>
            <div>
              <h1 className="tech-hero-title">{technologyName}</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-lg align-items-center justify-content-center mt-4">
            {/* ROW 1: VERSION & SEARCH (NARROWED) */}
            <div className="row  mb-4 ">
              <div className="col-12 col-xl-15 ">
                <div className="card shadow-sm border border-light-subtle">
                  <div className="card-header bg-white p-3 border-0 d-flex align-items-center">
                    
                    {/* Version Selector (LEFT) */}
                    <div style={{ width: "200px" }} >
                      <label className="text-uppercase small fw-bold text-muted mb-2 d-block" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Version</label>
                      <select
                        className="form-select border-secondary-subtle"
                        name="versions"
                        id="versions"
                        onChange={(e) => handleOnchange(e)}
                        style={{ height: '40px', borderRadius: '8px' }}
                      >
                        <option value="">Select version</option>
                        {versions?.map((d) => (
                          <option key={`v_id_${d.id}`} value={d.value}>
                            {d.value}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Search Field (CENTERED) */}
                    <div className="flex-grow-1  d-flex justify-content-center">
                      <div style={{ width: "100%", maxWidth: "450px" }}>
                        <label className="text-uppercase small fw-bold text-muted mb-2 d-block text-center" style={{ fontSize: '11px', letterSpacing: '0.5px' }}>Search Articles</label>
                        <div className="position-relative card ">
                          <input
                            type="text"
                            className="form-control rounded-pill border-secondary-subtle px-3"
                            style={{
                              height: "40px",
                              paddingRight: "40px",
                              fontSize: '14px'
                            }}
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <span className="position-absolute" style={{ top: "50%", right: "18px", transform: "translateY(-50%)", color: "#6c757d" }}>
                             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /></svg>
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Right Spacer */}
                    <div style={{ width: "200px" }}></div>
                  </div>
                </div>
              </div>
            </div>

            {/* ROW 2: SIDEBAR & DESCRIPTION (NARROWED) */}
            <div className="row card shadow-lg justify-content-center g-0 mb-4">
              <div className="col-12 col-xl-15">
                <div className="card shadow-sm border border-light-subtle overflow-hidden">
                  <div className="row g-0">
                    
                    {/* SIDEBAR */}
                    <div className="col-12 col-lg-4 col-xl-3 border-end border-light-subtle bg-white">
                      <div className="card-body p-0 custom-scroll" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <div className="list-group list-group-flush border-0">
                          {filteredQuestionData.length > 0 ? (
                            filteredQuestionData.map((qData, index) => (
                              <button
                                key={`q_id_${qData.questionData.id}`}
                                className={`list-group-item list-group-item-action border-0 py-3 px-4 ${
                                  index === questionIndex 
                                  ? "bg-primary-lt text-primary fw-bold" 
                                  : "text-dark"
                                }`}
                                onClick={() => handleGetDescription(qData.questionData.id, index)}
                                style={{ fontSize: '14px' }}
                              >
                                {qData.questionData.title}
                              </button>
                            ))
                          ) : (
                            <div className="p-4 text-center text-muted">No matching articles</div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* MAIN CONTENT AREA */}
                    <div className="col-12 col-lg-8 col-xl-9 d-flex flex-column bg-white card shadow-lg ">
                      <div className="card-body p-5 custom-scroll flex-grow-1" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                        <div className="article-content text-secondary" style={{ fontSize: '15px', lineHeight: '1.6' }}>
                           {parse(getHighlightedDescription(questionDescription))}
                        </div>
                      </div>
                      <div className="card-footer bg-white border-top border-light-subtle p-3 px-5">
                        {techQuestionData.length > 0 && (
                          <div className="d-flex gap-2">
                            {questionIndex !== 0 && (
                              <button
                                className={`btn ${activeBtn === "prev" ? "btn-primary" : "btn-outline-primary"} px-3 shadow-none`}
                                onClick={() => handlePrevDescription(questionIndex - 1)}
                              >
                                Prev
                              </button>
                            )}
                            {techQuestionData.length !== questionIndex + 1 && (
                              <button
                                className={`btn ${activeBtn === "next" ? "btn-primary" : "btn-outline-primary"} px-3 shadow-none ml-2`}
                                onClick={() => handleNextDescription(questionIndex + 1)}
                              >
                                Next
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* COMMENT FORM SECTION (NARROWED) */}
            {techQuestionData.length ? (
              <div className="row justify-content-center mt-4">
                <div className="col-12 col-xl-15">
                  <div className="card shadow-sm border border-light-subtle">
                    <div className="card-body p-4">
                      <form method="POST" onSubmit={submitComment} autoComplete="off">
                        <div className="row g-3">
                          {!loginUserId && (
                            <>
                              <div className="col-md-6">
                                <label className="form-label small fw-bold text-muted mb-2">Name</label>
                                <input
                                  type="text"
                                  className={`form-control shadow-none ${validate.validate?.userName ? "is-invalid" : ""}`}
                                  onChange={(e) => setUserName(e.target.value)}
                                  placeholder="Name"
                                  value={userName}
                                  style={{ borderRadius: '6px' }}
                                />
                              </div>
                              <div className="col-md-6">
                                <label className="form-label small fw-bold text-muted mb-2">Email</label>
                                <input
                                  type="text"
                                  className={`form-control shadow-none ${validate.validate?.email ? "is-invalid" : ""}`}
                                  onChange={(e) => setEmail(e.target.value)}
                                  placeholder="Email"
                                  value={email}
                                  style={{ borderRadius: '6px' }}
                                />
                              </div>
                            </>
                          )}
                          <div className="col-12 mt-3">
                            <textarea
                              name="comment"
                              className={`form-control border-secondary-subtle shadow-none ${validate.validate?.comment ? "is-invalid" : ""}`}
                              placeholder="Add your comment"
                              onChange={(e) => setComment(e.target.value)}
                              style={{ minHeight: "100px", borderRadius: '6px' }}
                              value={comment}
                            />
                          </div>
                          <div className="col-12 mt-3 text-start">
                            <button
                              type="submit"
                              className="btn btn-primary px-4 shadow-none"
                              style={{ borderRadius: '6px' }}
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}

            {/* THREADED COMMENTS LIST SECTION (NARROWED) */}
            {questCommentData?.length > 0 && (
              <div className="row justify-content-center mt-4 mb-5">
                <div className="col-12 col-xl-15">
                  <div className="card shadow-sm border border-light-subtle bg-white">
                    <div className="card-body p-4 custom-scroll" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                      <div className="chat ">
                  <div className="chat-bubbles">

                    {questCommentData.map((cData, index) => {

                      const nameParts = cData.name?.split(" ") || [];
                      const initials =
                        nameParts.length >= 2
                          ? (nameParts[0][0] + nameParts[1][0]).toUpperCase()
                          : (nameParts[0]?.[0] || "?").toUpperCase();

                      return (
                        <React.Fragment key={cData.id || index}>

                          {/* ================= MAIN COMMENT ================= */}
                          <div className="chat-item mb-3 d-flex align-items-start gap-2 position-relative">

                            {/* VERTICAL LINE FROM PARENT AVATAR DOWN TO REPLIES */}
                            {cData.commentReplyData?.length > 0 && (
                              <div
                                className="position-absolute"
                                style={{
                                  left: "19px",       /* Center of 40px avatar (20px minus 1px line width roughly) */
                                  top: "40px",        /* Starts immediately under the parent avatar */
                                  bottom: "-16px",    /* Stretches exactly through the mb-3 gap to hit the first reply */
                                  borderLeft: "1px solid #333",
                                  zIndex: 0
                                }}
                              ></div>
                            )}

                            {/* AVATAR */}
                            <div className="flex-shrink-0 mr-3 z-index-1 position-relative" style={{ zIndex: 1 }}>
                              {cData.commentUserData?.profile_photo_path ? (
                                <img
                                  src={CONST.HOST + cData.commentUserData.profile_photo_path}
                                  alt="profile"
                                  width={40}
                                  height={40}
                                  className="rounded-circle bg-white"
                                />
                              ) : (
                                <div
                                  className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                                  style={{ width: 40, height: 40 }}
                                >
                                  {initials}
                                </div>
                              )}
                            </div>

                            {/* CONTENT */}
                            <div className="flex-grow-1 ">

                              <div className="d-flex align-items-center mb-1">
                                {/* NAME */}
                                <div className="fw-bold me-3 ">
                                  {cData.commentUserData?.first_name
                                    ? `${cData.commentUserData.first_name} ${cData.commentUserData.last_name || ""}`
                                    : cData.name}
                                  <span className="ms-2 text-muted small fw-normal">
                                    {" "}• {getRelativeTime(cData.created_at)}
                                  </span>
                                </div>

                                {/* REPLY BUTTON */}
                                <button
                                  className="btn btn-sm text-primary p-0 d-inline-flex align-items-center gap-1 ml-3"
                                  onClick={() => replyHandler(cData.id, index)}
                                >
                                  <span>↩</span>
                                  <span className="ml-1 ">Reply</span>
                                </button>
                              </div>

                              {/* COMMENT */}
                              <div className="bg-light p-3 rounded-3 mt-2 mb-1 d-inline-block" style={{ fontSize: '14px', maxWidth: '85%', lineHeight: '1.5', color: '#495057' }}>
                                {cData.comment}
                              </div>

                              {/* REPLY BOX */}
                              {isReply && isCommentId === cData.id && (
                                <div className="mt-2" style={{ maxWidth: "400px" }}>

                                  <textarea
                                    className="form-control mb-2"
                                    placeholder="Write a reply..."
                                    rows="2"
                                    value={userReply}
                                    onChange={(e) => setUserReply(e.target.value)}
                                  />

                                  <div className="d-flex justify-content-end">
                                    <button
                                      className="btn btn-sm btn-light me-2"
                                      onClick={() => {
                                        setIsReply(false);
                                        setUserReply("");
                                      }}
                                    >
                                      Cancel
                                    </button>

                                    <button
                                      className="btn btn-sm btn-primary"
                                      onClick={(e) => submitReply(e, cData.id)}
                                    >
                                      Reply
                                    </button>
                                  </div>

                                </div>
                              )}

                            </div>
                          </div>

                          {/* ================= REPLIES (INDENTED INSIDE COMMENT) ================= */}
                          {cData.commentReplyData?.length > 0 && (
                            <div className="mt-0 position-relative mb-3" style={{ marginLeft: "48px" }}>

                              {cData.commentReplyData.map((replyData, rIndex, arr) => {
                                const isLast = rIndex === arr.length - 1;

                                const replyName = `${replyData.replyUserData?.first_name || ""} ${replyData.replyUserData?.last_name || ""}`.trim() || "?";
                                const rpParts = replyName.split(" ");
                                const rpInitials = rpParts.length >= 2
                                  ? (rpParts[0][0] + rpParts[1][0]).toUpperCase()
                                  : (rpParts[0]?.[0] || "?").toUpperCase();

                                return (
                                  <div
                                    key={replyData.id}
                                    className="d-flex align-items-start gap-2 mb-3 position-relative "
                                  >
                                    {/* The connecting curve line */}
                                    <div
                                      className="position-absolute"
                                      style={{
                                        left: "-29px",         /* Matches parent line coordinate precisely */
                                        top: "0px",            /* Starts exactly where previous line left off */
                                        width: "29px",         /* Matches offset */
                                        height: "16px",        /* Drives down to exact center of 32px avatar */
                                        borderBottom: "1px solid #333",
                                        borderLeft: "1px solid #333",
                                        borderBottomLeftRadius: "12px",
                                        zIndex: 0
                                      }}
                                    ></div>

                                    {/* Continuous vertical line for items that are NOT the last one */}
                                    {!isLast && (
                                      <div
                                        className="position-absolute"
                                        style={{
                                          left: "-29px",
                                          top: "16px",           /* Starts where the curve ended */
                                          bottom: "-16px",       /* Goes down through mb-3 gap to next item */
                                          borderLeft: "1px solid #333",
                                          zIndex: 0
                                        }}
                                      ></div>
                                    )}

                                    {/* AVATAR LEFT */}
                                    <div className="flex-shrink-0 z-index-1 position-relative ml-3" style={{ zIndex: 1 }}>
                                      {replyData.replyUserData?.profile_photo_path ? (
                                        <img
                                          src={CONST.HOST + replyData.replyUserData.profile_photo_path}
                                          width="32"
                                          height="32"
                                          className="rounded-circle mr-3 bg-white"
                                          alt="profile"
                                        />
                                      ) : (
                                        <div
                                          className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center border border-white"
                                          style={{ width: 32, height: 32, fontSize: "12px" }}
                                        >
                                          {rpInitials}
                                        </div>
                                      )}
                                    </div>

                                    {/* CONTENT RIGHT */}
                                    <div className="flex-grow-1 z-index-1 " style={{ zIndex: 1, marginTop: "4px" }}>
                                      <div className="fw-bold small text-dark mb-1 d-flex align-items-center ">
                                        <span>{replyName}</span>
                                        <span className="ms-2 text-muted small fw-normal">
                                          • {getRelativeTime(replyData.created_at)}
                                        </span>
                                        {loginUserId == replyData.user_id && (
                                          <div className="d-flex gap-2 ml-3">
                                            <button
                                              className="btn btn-sm text-secondary p-0"
                                              onClick={() => {
                                                setIsEditingReply(replyData.id);
                                                setEditingReplyText(replyData.reply);
                                              }}
                                              title="Edit Reply"
                                            >
                                              <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                                                <line x1="13.5" y1="6.5" x2="17.5" y2="10.5"></line>
                                              </svg>
                                            </button>
                                            <button
                                              className="btn btn-sm text-secondary p-0"
                                              onClick={() => deleteReply(replyData.id)}
                                              title="Delete Reply"
                                            >
                                              <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                <line x1="4" y1="7" x2="20" y2="7"></line>
                                                <line x1="10" y1="11" x2="10" y2="17"></line>
                                                <line x1="14" y1="11" x2="14" y2="17"></line>
                                                <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                                <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                              </svg>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                      {isEditingReply === replyData.id ? (
                                        <div className="mt-1" style={{ maxWidth: "400px" }}>
                                          <textarea className="form-control form-control-sm mb-2 shadow-none" value={editingReplyText} onChange={(e) => setEditingReplyText(e.target.value)} rows="2" style={{ fontSize: '13px', borderRadius: '6px' }} />
                                          <div className="d-flex justify-content-end gap-2">
                                            <button className="btn btn-ghost-secondary circle btn-sm" onClick={() => setIsEditingReply("")}>Cancel</button>
                                            <button className="btn btn-primary circle btn-sm" onClick={() => updateReply(replyData.id)}>Update</button>
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="bg-light p-2 px-3 rounded-3 mt-1 d-inline-block" style={{ fontSize: '13px', lineHeight: '1.4', color: '#495057' }}>
                                          {replyData.reply}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Technologies;
